import { ArrowForward } from "@material-ui/icons";
import Cookies from "js-cookie";
import React, { useEffect } from "react";

type Props = {
    title: string;
    body: string;
};

const Welcome: React.FC<Props> = ({title, body}) => {
    useEffect(() => {
        if (!Cookies.get("welcomed")) {
            setTimeout(() => {
                let elem = document.getElementById("welcome-modal");
                if (elem) {
                    elem.style.display = "grid";
                }
            }, 500);
        }
    }, []);

    const accept = () => {
        Cookies.set('welcomed', "1");
        let elem = document.getElementById("welcome-modal");
        if (elem) {
            elem.style.display = "none";
        }
    };

    return (
        <div
            className="modal modal-container"
            id="welcome-modal"
            style={{ display: "none" }}
        >
            <div className="modal-wrapper">
                <h4>
                    {title}
                </h4>
                <p></p>
                <p>
                    {body}
                </p>
                <div className="modal-actions">
                    <div></div>
                    <button onClick={accept} className="icon_button">
                        <ArrowForward />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Welcome;
